// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $Model,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  Col,
  Row,
} from 'reactstrap';
import {
  AvField,
} from 'availity-reactstrap-validation';

// Types
type $OptionalProps = {
  onChange?: () => unknown;
};

type $Props = $OptionalProps & $Translate & {
  item: $Model<'Admin'>;
};

const ProfileInvoiceFieldsView = function ({
  item,
  onChange,
  t,
}: $Props) {
  return (
    <>
      <Row>
        <Col>
          <AvField
            label={t('Company name')}
            name={'InvoiceName'}
            onChange={onChange}
            value={item.InvoiceName}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Registration no.')}
            name={'InvoiceNo'}
            onChange={onChange}
            value={item.InvoiceNo}
          />
        </Col>
        <Col>
          <AvField
            label={t('VAT no.')}
            name={'InvoiceVat'}
            onChange={onChange}
            value={item.InvoiceVat}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AvField
            label={t('Address')}
            name={'InvoiceAddress'}
            onChange={onChange}
            value={item.InvoiceAddress}
          />
        </Col>
      </Row>
    </>
  );
};

ProfileInvoiceFieldsView.defaultProps = {
  onChange: undefined,
};

export default ProfileInvoiceFieldsView;
